import middlewares from '@/middlewares/http-common';
import { handleResponse, handleError } from './ResponseHandlers.js';
import { AccountClass } from 'interface/account.js';

class AuthService {
  getUserToken(clientId: string) {
    return middlewares.httpJson
      .get('/auth/token', {
        params: {
          clientId: clientId,
        },
      })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  signIn(login: string, password: string) {
    return middlewares.httpJson
      .post('/auth/signin', {
        login: login,
        password: password,
      })
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  checkAdmin() {
    return middlewares.httpJson
      .get('/auth/admin', {})
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  createClientPanelAccount(clientId: string, email: string, password: string) {
    const accountInterface = new AccountClass({
      clientId,
      email,
      password,
    });

    return middlewares.httpJson
      .post('/auth/signup', accountInterface)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }
}

export default new AuthService();
